import React from 'react';
import styled from 'styled-components';
import { theme } from '../../../../theme';
import { BaseDesktopSearchCard } from '../Base';
import { SearchCard } from '../types';
import {
  Title,
  GrayUIText,
  Price,
  GrayPrice,
  BottomContent,
} from '../Base/styles';
import {
  BoxConditionIcon,
  CartIcon,
  MapMarkerIcon,
  TruckIcon,
} from '../../../../assets';
import { Pill } from '../../../basePill';

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacings[2].rem};
  margin: ${theme.spacings[2].rem};
  overflow: hidden;
`;

const FlexContainer = styled.div<{ horizontalAlign: HorizontalAlign }>`
  display: flex;
  justify-content: ${({ horizontalAlign }) => horizontalAlign};
`;

const StyledPrice = styled(Price)`
  min-height: 34px;
`;

const StyledGrayPrice = styled(GrayPrice)`
  margin-bottom: ${theme.spacings[0].rem};
  align-self: center;
`;

type HorizontalAlign = 'end' | 'space-between';

type SearchCardProps = SearchCard<'BuyNow'> & {
  horizontalAlign: HorizontalAlign;
};

export const BuyNowDesktopSearchCard: React.FC<SearchCardProps> = ({
  title,
  condition,
  location,
  isDelivery,
  price,
  grayPrice,
  data,
  type,
  horizontalAlign = 'end',
  ...props
}) => {
  return (
    <BaseDesktopSearchCard {...props}>
      <Content>
        <Title>{title}</Title>
        <FlexContainer horizontalAlign={grayPrice ? 'space-between' : 'end'}>
          {grayPrice && <StyledGrayPrice>{grayPrice}</StyledGrayPrice>}
          <Pill
            backgroundColor={theme.colors.tints.systemBlue[6]}
            icon={CartIcon}
          >
            Buy Now
          </Pill>
        </FlexContainer>
        <StyledPrice>{price}</StyledPrice>
        <BottomContent>
          <GrayUIText>
            <BoxConditionIcon
              width={16}
              fill={theme.colors.neutrals.solidGrays[3]}
            />
            {condition}
          </GrayUIText>
          <GrayUIText>
            {isDelivery ? (
              <>
                <TruckIcon
                  width={16}
                  fill={theme.colors.neutrals.solidGrays[3]}
                />
                Delivery
              </>
            ) : (
              <>
                <MapMarkerIcon
                  width={16}
                  fill={theme.colors.neutrals.solidGrays[3]}
                />
                {location}
              </>
            )}
          </GrayUIText>
        </BottomContent>
      </Content>
    </BaseDesktopSearchCard>
  );
};
